var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Box, Button, Card, CardContent, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography, } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAcceptOwnershipByToken, usePreviewOwnershipByToken, } from "../api/InvitationApiProvider";
import { useRetrieveTeamsByPlayerId, useRetrievePlayerByUserId, } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
export var AcceptOwnershipByToken = function () {
    var token = useParams().token;
    var navigate = useNavigate();
    var _a = __read(React.useState(""), 2), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = __read(useState(""), 2), mergeIntoTeamId = _b[0], setMergeIntoTeamId = _b[1];
    var user = React.useContext(UserContext).user;
    var player = useRetrievePlayerByUserId({
        userId: (user === null || user === void 0 ? void 0 : user.pk) ? Number(user.pk) : undefined,
    }).data;
    var myTeams = useRetrieveTeamsByPlayerId({
        playerId: player === null || player === void 0 ? void 0 : player.id,
    }).data;
    var _c = usePreviewOwnershipByToken({ token: token }), invitation = _c.data, isPreviewLoading = _c.isLoading, isPreviewError = _c.isError;
    var acceptMutation = useAcceptOwnershipByToken({
        onMutate: function () { },
        onSuccess: function () {
            var targetTeam = typeof mergeIntoTeamId === "number"
                ? mergeIntoTeamId
                : invitation === null || invitation === void 0 ? void 0 : invitation.team;
            navigate(targetTeam ? "/teams/".concat(targetTeam) : "/teams");
        },
        onError: function (error) {
            var _a, _b;
            var messages = Object.values((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {})
                .flat()
                .join(" ");
            setErrorMessage(messages || "Failed to accept ownership. The link may be invalid.");
        },
    });
    var declineMutation = useAcceptOwnershipByToken({
        onMutate: function () { },
        onSuccess: function () { return navigate("/teams"); },
        onError: function () { return setErrorMessage("Failed to decline ownership invitation."); },
    });
    if (!token) {
        return (_jsx(Box, { sx: { textAlign: "center", mt: 8 }, children: _jsx(Typography, { variant: "h5", color: "error", children: "Invalid ownership invitation link" }) }));
    }
    if (isPreviewLoading) {
        return _jsx(Loading, {});
    }
    var isProcessing = acceptMutation.isLoading || declineMutation.isLoading;
    // Filter out the invited team from merge options
    var mergeableTeams = (myTeams || []).filter(function (t) { return t.id !== (invitation === null || invitation === void 0 ? void 0 : invitation.team); });
    return (_jsxs(React.Fragment, { children: [_jsx(Box, { sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "60vh",
                }, children: _jsx(Card, { variant: "outlined", sx: { maxWidth: 500, width: "100%", p: 2 }, children: _jsx(CardContent, { sx: { textAlign: "center" }, children: isProcessing ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { sx: { mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: acceptMutation.isLoading
                                        ? "Accepting ownership..."
                                        : "Declining..." })] })) : isPreviewError || !invitation ? (_jsxs(_Fragment, { children: [_jsx(SwapHorizIcon, { color: "error", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Invalid invitation" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: "This ownership invitation link is invalid or has already been used." })] })) : (_jsxs(_Fragment, { children: [_jsx(SwapHorizIcon, { color: "primary", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "You've been invited to own" }), _jsx(Typography, { variant: "h4", sx: { fontWeight: 700, mb: 1 }, children: invitation.teamName }), _jsxs(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 1 }, children: ["Invited by ", invitation.inviterFirstName, " ", invitation.inviterLastName] }), invitation.message && (_jsxs(Typography, { variant: "body1", sx: {
                                        mb: 2,
                                        fontStyle: "italic",
                                        p: 2,
                                        bgcolor: "grey.50",
                                        borderRadius: 1,
                                    }, children: ["\u201C", invitation.message, "\u201D"] })), mergeableTeams.length > 0 && (_jsxs(FormControl, { fullWidth: true, sx: { mb: 2, textAlign: "left" }, children: [_jsx(InputLabel, { children: "Merge Into Existing Team (Optional)" }), _jsxs(Select, { value: mergeIntoTeamId, onChange: function (e) {
                                                return setMergeIntoTeamId(e.target.value);
                                            }, label: "Merge Into Existing Team (Optional)", children: [_jsx(MenuItem, { value: "", children: _jsx("em", { children: "None \u2014 keep as separate team" }) }), mergeableTeams.map(function (team) { return (_jsx(MenuItem, { value: team.id, children: team.name }, team.id)); })] }), _jsx(Typography, { variant: "caption", color: "text.secondary", sx: { mt: 0.5 }, children: "Optionally merge this team's data into one of your existing teams." })] })), _jsxs(Box, { sx: { display: "flex", gap: 2, justifyContent: "center" }, children: [_jsx(Button, { variant: "contained", color: "success", size: "large", startIcon: _jsx(CheckCircleIcon, {}), onClick: function () {
                                                return acceptMutation.mutate(__assign({ token: token, status: "ACCEPTED" }, (mergeIntoTeamId
                                                    ? { mergeIntoTeamId: mergeIntoTeamId }
                                                    : {})));
                                            }, children: "Accept" }), _jsx(Button, { variant: "outlined", color: "error", size: "large", startIcon: _jsx(DoNotDisturbIcon, {}), onClick: function () {
                                                return declineMutation.mutate({
                                                    token: token,
                                                    status: "DECLINED",
                                                });
                                            }, children: "Decline" })] })] })) }) }) }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
